export default __webpack_public_path__ + "static/media/icon-add.b49bf8e1.svg";